import React from 'react';
import {useTranslation} from 'react-i18next';
import StepAnimation from './StepAnimation';

const HowItWorks = () => {
    const {t} = useTranslation();
    const steps = ['customize', 'purchase', 'download'];
    return (
        <section id="howItWorks" className="design-section">
            <div className="design-container">
                <h2>{t('howItWorks.title')}</h2>
                <p className="section-subtitle">{t('howItWorks.subtitle')}</p>
                <div className="steps-grid">
                    {steps.map((step, i) => (
                        <article className="step-card" key={step}>
                            <StepAnimation step={step} label={t(`howItWorks.${i}.title`)}/>
                            <div className="step-copy">
                                <span className="step-number">0{i + 1}</span>
                                <h3>{t(`howItWorks.${i}.title`)}</h3>
                                <p>{t(`howItWorks.${i}.subtitle`)}</p>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};
export default HowItWorks;
